export default __webpack_public_path__ + "static/media/activeseen.14e6b4e0.svg";